
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/emak-informa/[slug]",
      function () {
        return require("private-next-pages/emak-informa/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/emak-informa/[slug]"])
      });
    }
  